import { ADD_BG_IMAGE, REMOVE_BG_IMAGE } from '../actions/bg-image';


export default (state = '', action) => {

    switch (action.type) {
        case ADD_BG_IMAGE: {
            return state = action.payload;
        }

        case REMOVE_BG_IMAGE: {
            return state = '';
        }

        default: return state;
    }
}